document.addEventListener("DOMContentLoaded", function () {
  const bar = document.getElementById("custom-utility-nav-banner");
  const closeBtn = document.getElementById(
    "custom-utility-nav-banner__banner-close"
  );

  if (!bar) return;

  if (!localStorage.getItem("utilityNavClosed")) {
    bar.classList.remove("hidden");
  } else {
    if (typeof updateHeaderTop === "function") updateHeaderTop();
    if (typeof updateOverlayTop === "function") updateOverlayTop();
  }

  // Close button logic
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      bar.classList.add("hidden");
      localStorage.setItem("utilityNavClosed", "true");

      if (typeof updateHeaderTop === "function") updateHeaderTop();
      if (typeof updateOverlayTop === "function") updateOverlayTop();
    });
  }
});
